import { useCMSPageField } from '@/cms/fields'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export interface GoodToKnowProps {
  title: string
}

export function GoodToKnow({ title }: GoodToKnowProps) {
  const info = useCMSPageField('PDP.attention')

  if (info === '')
    return null

  return (
    <Item elementDL="Good to know" title={title} Glyph="InformationInCircle">
      {/* eslint-disable-next-line react-dom/no-dangerously-set-innerhtml -- Content comes from datasource */}
      <Typography dangerouslySetInnerHTML={{ __html: info }} />
    </Item>
  )
}
